import { render } from "./TableWithCustomHeader.vue?vue&type=template&id=19f900aa"
import script from "./TableWithCustomHeader.vue?vue&type=script&lang=js"
export * from "./TableWithCustomHeader.vue?vue&type=script&lang=js"
script.render = render

export default script